import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=534be8d9&scoped=true&"
import script from "./paymentInfo.vue?vue&type=script&lang=js&"
export * from "./paymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=534be8d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534be8d9",
  null
  
)

export default component.exports